import React, { useState } from "react";

import { PLAY_SOUND } from "../../constants/types/commands";
import { useSendCommand } from "../../hooks/use-send-command";

import styles from "./styles.modules.scss";

export const Pressable = ({
    children,
    animationSize,
    sound = "OKButton",
    disabled,
}: {
    children: JSX.Element;
    animationSize?: "small" | "large";
    sound?: string;
    disabled?: boolean;
}) => {
    const [state, setState] = useState<"initial" | "released" | "pressed">(
        "initial",
    );

    const sendCommand = useSendCommand();

    const press = () => {
        if (disabled) return;

        setState("pressed");
    };

    const release = () => {
        if (disabled) return;

        setState("released");
    };

    const handlePointerLeave = () => {
        if (disabled) return;
        if (state !== "pressed") return;

        release();
    };

    const handleClick = () => {
        if (disabled) return;

        sendCommand(PLAY_SOUND, sound);
    };

    return (
        <div
            className={`pressable ${styles.pressable} is-${state} ${
                styles[state] || ""
            } animation-${animationSize} ${
                styles[`${animationSize}Animation`]
            } `}
            onPointerDown={press}
            onPointerUp={release}
            onPointerLeave={handlePointerLeave}
            onClick={handleClick}
        >
            {children}
        </div>
    );
};
